export default function (element, data) {
    const cat = element.querySelector(".cat"); // Блок 1
    const croc = element.querySelector(".croc"); // Блок 2
    const mobileText = {
        cat: element.querySelector(".mobile-text .cat").innerText,
        croc: element.querySelector(".mobile-text .croc").innerText
    }

    let intervals = [];
    const desktopIntervals = [500, 3000];
    const mobileIntervals = [100, 7500];

    const isMobile = window.matchMedia("only screen and (max-width: 960px)").matches;
    const isiPhone = () => /iPhone|iPad|iPod/i.test(navigator.userAgent);

    if (isMobile || isiPhone()) {
        intervals = mobileIntervals;
    } else {
        intervals = desktopIntervals;
    }

    //start(); // Запуск

    window.addEventListener("slidethreestart", start); // Слушатель события
    window.addEventListener("slidethreereset", reset); // Слушатель события

    function start(event) {
        setTimeout(function() {
            cat.classList.add("active");
        }, intervals[0]);
        setTimeout(function() {
            if(element.classList.contains("active")) {
                cat.querySelector(".cat-text").classList.add("active");
                window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: mobileText.cat}}));
                cat.querySelector(".cloud-mobile").classList.add("show");
            }
        }, intervals[0]);

        setTimeout(function() {
            croc.classList.add("active");
        }, intervals[0]);
        setTimeout(function() {
            if(element.classList.contains("active")) {
                croc.querySelector(".croc-text").classList.add("active");
                window.dispatchEvent(new CustomEvent("mobiletextupdate", {detail: {text: mobileText.croc}}));
                croc.querySelector(".cloud-mobile").classList.add("show");
                cat.querySelector(".cloud-mobile").classList.remove("show");
            }
        }, intervals[1]);


        // Эффект FADE после таймаута
        let fadeTimeout = event.detail - 500;
        setTimeout(function() {
            cat.classList.remove("active");
            croc.classList.remove("active");
        }, fadeTimeout);
    }

    // Сброс анимации
    function reset() {
        cat.querySelector(".cat-text").classList.remove("active");
        cat.querySelector(".cloud-mobile").classList.remove("show");

        croc.querySelector(".croc-text").classList.remove("active");
        croc.querySelector(".cloud-mobile").classList.remove("show");
    }
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
